<template>

<transition name="fade">
    <div :class="['message-component', { block: block } ]">
        {{ localMessage }}
        <svg v-if="loading" version="1.1" id="L4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 52 12" enable-background="new 0 0 0 0" xml:space="preserve">
            <circle fill="#999" stroke="none" cx="6" cy="6" r="6">
                <animate
                attributeName="opacity"
                dur="1s"
                values="0;1;0"
                repeatCount="indefinite"
                begin="0.1"/>
            </circle>
            <circle fill="#999" stroke="none" cx="26" cy="6" r="6">
                <animate
                attributeName="opacity"
                dur="1s"
                values="0;1;0"
                repeatCount="indefinite"
                begin="0.2"/>
            </circle>
            <circle fill="#999" stroke="none" cx="46" cy="6" r="6">
            <animate
                attributeName="opacity"
                dur="1s"
                values="0;1;0"
                repeatCount="indefinite"
                begin="0.3"/>
            </circle>
        </svg>
    </div>
</transition>

</template>

<script>
export default {
    name: 'message',
    props: {
        message: {
            type: String,
            default: ''
        },
        loading: {
            type: [String, Boolean],
            default: false
        },
        delay: {
            type: [String, Number],
            default: 5
        },
        block: {
            type: [String, Boolean],
            default: false
        }
    },
    watch: {
        message: function(value) {
            this.localMessage = value
        }
    },
    data() {
        return {
            localMessage: this.message
        }
    }
}
</script>

<style lang="scss" scoped>
.message-component {
    height: 2.25em;
    display: inline-block;
    padding: 0 0 0 1em;
    span, img { float: left; }
    img { margin: 0 1em 0 0; }
}
.block {
    display: block;
    padding: 0.5em 0;
}
div { margin: 0.25em 0; }
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0
}
svg{
  width: 52px;
  height: 12px;
  margin: 0 0 0 0.5em;
  display: inline-block;
}
</style>
